import { render, staticRenderFns } from "./SemiologiaPsicologica.vue?vue&type=template&id=756d67b6"
import script from "./SemiologiaPsicologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaPsicologica.vue?vue&type=script&lang=js"
import style0 from "./SemiologiaPsicologica.vue?vue&type=style&index=0&id=756d67b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports